// src/pages/Home.jsx
import React from 'react';
import Hero from '../components/Hero';
import Cards from '../components/Cards'; // Adjust path if Navbar is in a different folder
import WhoAreWe from '../components/WhoAreWe'; 
import Footer from '../components/Footer'; 
import HowWeWork from '../components/HowWeWork'; 
const Home = () => {
  return (
    <div>
     
      <Hero />
      <Cards />
      <HowWeWork />
      <WhoAreWe />  
    </div>
  );
};

export default Home;

